import { createContext, useContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import type { Command } from '../components/primitives';

interface BrainBarState {
  pageCommands: Command[];
  setPageCommands: (c: Command[]) => void;
}

const BrainBarContext = createContext<BrainBarState>({
  pageCommands: [],
  setPageCommands: () => {},
});

export function BrainBarProvider({ children }: { children: ReactNode }) {
  const [pageCommands, setPageCommands] = useState<Command[]>([]);
  return (
    <BrainBarContext.Provider value={{ pageCommands, setPageCommands }}>
      {children}
    </BrainBarContext.Provider>
  );
}

export function useBrainBarContext() {
  return useContext(BrainBarContext);
}

/**
 * Page hook: register commands while mounted.
 * Pass a stable array (memoize) to avoid re-registering every render.
 */
export function usePageCommands(commands: Command[]) {
  const { setPageCommands } = useBrainBarContext();
  useEffect(() => {
    setPageCommands(commands);
    return () => setPageCommands([]);
  }, [commands, setPageCommands]);
}
